import { useEffect } from 'react';
import {
  getMUICache,
  appendStyleSheet,
  getImageId,
  getImageUrl,
  getImageSize,
  convertEpochTime,
  fetchAnchorValue
} from '../../../common/utils';

import { CacheProvider } from '@emotion/react';
import './HomeWebStories.css';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const { showDate, item, background, isCarousel, isViewport, anchorLinksValue } = props;
  const { hl, imageid, pubInfo, id, wu, upd, tn } = item;
  const cache = getMUICache();
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

      useEffect(()=>{
          EagerLoadImages()
      },[]);

  let styles = require('./HomeWebStories.css');
  appendStyleSheet('HomeWebStories', styles);
  return (
    <CacheProvider value={cache}>
      {!isCarousel ? (
                      <a
                      role="link"
                      aria-label="Next Page"
                      href={
                        wu?.startsWith('http')
                          ? wu
                          : wu?.startsWith('/')
                          ? wu
                          : '/' + wu
                      }
                      target={fetchAnchorValue(anchorLinksValue, wu?.startsWith('http')
                        ? wu
                        : wu?.startsWith('/')
                        ? wu
                        : '/' + wu)} 
                      className='ThemeThreeHomeWebStroiesAnchor'
                    >
        <div className="ThemeThreeHomeWebStroies">
          <div
            className="ThemeThreeHomeWebStroiesCardWrap"
            style={{ background: background }}
          >
            <div className="ThemeThreeHomeWebStroiesardImgWrap">

                <figure className="ThemeThreeHomeWebImageWrapper">
                  {getImageSize(imageid) ? (
                    <picture>
                      <source
                        media="(min-width: 768px)"
                        srcSet={getImageUrl(
                          getImageId(imageid),
                          getImageSize(imageid),
                          356,
                          475,
                          pubInfo.baseDomain,
                          false,
                          props.CONSTANTS, '8'
                        )}
                      />
                      <source
                        media="(max-width: 768px)"
                        srcSet={getImageUrl(
                          getImageId(imageid),
                          getImageSize(imageid),
                          265,
                          354,
                          pubInfo.baseDomain,
                          false,
                          props.CONSTANTS,'8'
                        )}
                      />

                      {isViewport ? (
                        <img
                          alt={hl?.substring(0, 25)}
                          title={hl?.substring(0, 25)}
                          loading="lazy"
                        />
                      ) : (
                        <img
                          alt={hl?.substring(0, 25)}
                          title={hl?.substring(0, 25)}
                          loading="lazy"
                        />
                      )}
                    </picture>
                  ) : (
                    <img
                    src=""
                      className="fallback"
                      alt={hl?.substring(0, 25)}
                      title={hl?.substring(0, 25)}
                      loading="lazy"
                    />
                  )}

                  {tn !== 'MEDIAAUDIO' || tn !== 'MEDIAVIDEO'}
                </figure>
             
            </div>

            <div className="ThemeThreeHomeWebStroiesMainContentWrap">
              <div className="ThemeThreeHomeWebStroiesContentWrap">
                <p className="ThemeThreeHomeWebStroiesDiscription"> {hl}</p>
              </div>
              <div className="themeThreedateAgencyWrap">
                {showDate && (
                  <p className="ThemeThreeCommonAuthorWrapper">
                    {convertEpochTime(upd, 'updated', 'DD MMM YYYY')}
                  </p>
                )}
              </div>{' '}
            </div>
          </div>
        </div>
        </a>
      ) : (
        <div
          className="quickview_main_wrap"
          style={{ background: background }}
        >
          <div className="quickview_wrap">
            <a
              role="link"
              aria-label="Next Page"
              href={
                wu?.startsWith('http')
                  ? wu
                  : wu?.startsWith('/')
                  ? wu
                  : '/' + wu
              }
              target={fetchAnchorValue(anchorLinksValue, wu?.startsWith('http')
                  ? wu
                  : wu?.startsWith('/')
                  ? wu
                  : '/' + wu)} 
            >
              <figure className="image-wrapper">
                {getImageSize(imageid) && (
                  <picture>
                    {/* Add multiple source elements for different image sources */}
                    <source
                      media="(min-width: 768px)"
                      srcSet={getImageUrl(
                        id,
                        getImageSize(imageid),
                        266,
                        undefined,
                        pubInfo.baseDomain,
                        false,
                        props.CONSTANTS,
                      )}
                    />
                    <source
                      media="(min-width: 320px)"
                      srcSet={getImageUrl(
                        id,
                        getImageSize(imageid),
                        156,
                        undefined,
                        pubInfo.baseDomain,
                        false,
                        props.CONSTANTS,
                      )}
                    />
                    {/* Fallback image for browsers that do not support the picture element */}
                    {isViewport ? (
                      <img
                        alt={hl?.substring(0, 25)}
                        title={hl?.substring(0, 25)}
                        loading="lazy"
                      />
                    ) : (
                      <img
                        loading="lazy"
                        alt={hl?.substring(0, 25)}
                        title={hl?.substring(0, 25)}
                      />
                    )}
                  </picture>
                )}
              </figure>

              <div className="itemtitlewrap">
                <h5 className="itemTitle"> {hl}</h5>
                <div className="authorWrap">
                  {showDate && (
                    <div className="Authordetails">
                      <h6 className="showtime commonset">
                        {convertEpochTime(upd, 'updated', 'DD MMM YYYY')}
                      </h6>
                    </div>
                  )}
                </div>
              </div>
            </a>
          </div>
        </div>
      )}
    </CacheProvider>
  );
};
export default Card;
